import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [state, setState] = useState("checking"); // checking | done | error
  const attempts = useRef(0);

  useEffect(() => {
    let timer;
    if (!sessionId) {
      setState("error");
      return;
    }
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid" || data.status === "completed") {
          await checkAuth();
          setState("done");
          setTimeout(() => navigate("/"), 1200);
          return;
        }
      } catch (e) {}
      if (attempts.current >= 20) {
        setState("error");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, checkAuth, navigate]);

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6">
      <div className="text-center max-w-sm" data-testid="payment-success">
        {state === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-5" />
            <h1 className="font-heading text-2xl font-bold mb-2">Confirming your payment…</h1>
            <p className="text-slate-400 text-sm">Hang tight, this only takes a moment.</p>
          </>
        )}
        {state === "done" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-5" />
            <h1 className="font-heading text-2xl font-bold mb-2">You're all set!</h1>
            <p className="text-slate-400 text-sm">Taking you to your Rolodex…</p>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle className="w-14 h-14 text-blue-500 mx-auto mb-5" />
            <h1 className="font-heading text-2xl font-bold mb-2">Still processing</h1>
            <p className="text-slate-400 text-sm mb-6">
              Your payment may still be completing. Head back and it should unlock shortly.
            </p>
            <button
              onClick={() => navigate("/")}
              className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold transition-colors"
            >
              Go to app
            </button>
          </>
        )}
      </div>
    </div>
  );
}
